import { z } from 'zod'
import { leadSchema } from '@nwwp/database'

const currencySchema = z.coerce.number().min(0).max(9_999_999_999)

export const funnelSchema = z.object({
  age: z.coerce.number().min(18, 'You must be at least 18 years old').max(120, 'Are you really this old?'),
  zip_code: z.string().regex(/^\d{5}$/, 'Please enter a valid 5-digit ZIP code'),
  city: z.string().min(1).max(50),
  state_abbreviation: z
    .string()
    .min(2)
    .max(2)
    .transform((state) => state.toUpperCase()),
  marital_status: leadSchema.shape.marital_status.nonoptional(),
  household_income: currencySchema,
  first_name: z.string().min(1).max(50),
  last_name: z.string().min(1).max(50),
  email: z.email('Please enter a valid email'),
  phone: z
    .string()
    .min(10, 'Please enter a valid phone number')
    .max(10, 'Please enter a valid phone number')
    .transform((phone) => `+1${phone}`),
  // Investable Assets is captured as a single self-reported figure (NWA-3479); aum = investments.
  investments: currencySchema.optional(),

  // Support fields, these are NOT passed downstream to server
  otp: z.string().regex(/^\d{6}$/),
  verified_otp: z.boolean(),

  // Reuse the enum from leadSchema (extracted to avoid version conflicts)
  investable_assets_range: leadSchema.shape.investable_assets_range,
  aum: currencySchema,
})

export type FunnelSchema = z.infer<typeof funnelSchema>
